import React, { useEffect, useState } from 'react'
import Axios from 'axios';
import { Col, Row, Card, Spin } from 'antd';
import { price } from './Sections/Datas';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getThumbURLfromProduct } from '../../utils/YoutubeEmbed';
import ProductCard from '../../utils/ProductCard';
import { useDispatch, useSelector } from 'react-redux';
import { getChatMessages } from '../../../_actions/user_actions';

export const DivCard = styled.div`
    background: #fff;
    width: 100%;
    border-radius: 3px;
    padding: 10px;
    &:not(:first-child){
        margin: 1px;
    }
`;

export const DivHorizental = styled.div`
    display: flex;

    ${({ margin }) => margin && css`
        > * :not(:first-child) {
            margin-left: ${margin};
        }
    `}
`;

export const DivVertical = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px;
`;
// const Card = styled.div`
//     padding: 10px;
//     background: #fff;
//     color: #555;
// `;

if (window.Android) window.Android.getToken('Loading...');

export const renderProductCards = (products) => products.map(product => {

    let imgURL = getThumbURLfromProduct(product);


    return <Col key={product._id} lg={24} md={24} xs={24}>
        <Link to={`/product/${product._id}`} >
            <Card cover={
                imgURL && <img alt="productImg" src={imgURL} style={{ height: '30vh' }} />
            }>
                <ProductCard user={product.writer} product={product} ellepsis />
            </Card>
        </Link>
    </Col>
});

function LandingPage() {

    const [Products, setProducts] = useState([])
    const [Skip, setSkip] = useState(0)
    const [Limit, setLimit] = useState(10)
    const [PostSize, setPostSize] = useState()
    const [SearchTerms, setSearchTerms] = useState("")
    const [BlankMessage, setBlankMessage] = useState()
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();

    const [Filters, setFilters] = useState({
        types: [],
        price: []
    })

    useEffect(() => {
        dispatch(getChatMessages());
        
        const FCM_Registration_Token = localStorage.getItem('fcmregtk');
        // console.log('FCM_Registration_Token', FCM_Registration_Token);
        if (FCM_Registration_Token) {
            Axios.post('/api/user/update', { fcmregtk: FCM_Registration_Token });
        }
    }, []);

    useEffect(() => {

        const variables = {
            skip: Skip,
            limit: Limit,
            filters: { friends: user?.userData?.friends }
        };

        getProducts(variables);

    }, [Limit, Skip, user]);

    const getProducts = (variables) => {
        Axios.post('/api/product/getProducts', variables)
            .then(response => {
                if (response.data.success) {
                    let totalProducts;
                    if (variables.loadMore || variables.skip > Skip) {
                        totalProducts = [...Products, ...response.data.products];
                    } else {
                        totalProducts = response.data.products;
                    }
                    setProducts(totalProducts);
                    setPostSize(response.data.postSize);

                    if (!totalProducts?.length) setBlankMessage('모집 글을 등록해 주세요');

                } else {
                    console.log('Failed to fectch product datas')
                }
            })
    }

    const onLoadMore = () => {
        let skip = Skip + Limit;

        const variables = {
            skip: skip,
            limit: Limit,
            loadMore: true,
            // filters: Filters,
            filters: { friends: user?.userData?.friends },
            searchTerm: SearchTerms
        };

        getProducts(variables);
        setSkip(skip);
    }


    const showFilteredResults = (filters) => {

        const variables = {
            skip: 0,
            limit: Limit,
            filters: filters

        }
        getProducts(variables)
        setSkip(0)

    }

    const handlePrice = (value) => {
        const data = price;
        let array = [];

        for (let key in data) {

            if (data[key]._id === parseInt(value, 10)) {
                array = data[key].array;
            }
        }
        console.log('array', array)
        return array
    }

    const handleFilters = (filters, category) => {

        const newFilters = { ...Filters }

        newFilters[category] = filters

        if (category === "price") {
            let priceValues = handlePrice(filters)
            newFilters[category] = priceValues

        }

        console.log(newFilters)

        showFilteredResults(newFilters)
        setFilters(newFilters)
    }

    const updateSearchTerms = (newSearchTerm) => {

        const variables = {
            skip: 0,
            limit: Limit,
            filters: Filters,
            searchTerm: newSearchTerm
        }

        setSkip(0)
        setSearchTerms(newSearchTerm)

        getProducts(variables)
    }


    return (
        <div className='page'>

            {/* Filter  */
            /* <Row gutter={[16, 16]}>
                <Col lg={12} xs={24} >
                    <CheckBox
                        list={types}
                        handleFilters={filters => handleFilters(filters, "types")}
                    />
                </Col>
                <Col lg={12} xs={24}>
                    <RadioBox
                        list={price}
                        handleFilters={filters => handleFilters(filters, "price")}
                    />
                </Col>
            </Row> */}

            {/* Search  */}
            {/* <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '1rem auto' }}>

                <SearchFeature
                    refreshFunction={updateSearchTerms}
                />

            </div> */}

            {Products?.length ?
                // <div style={{ display: 'flex', height: '300px', justifyContent: 'center', alignItems: 'center' }}>
                <Row gutter={[16, 16]} style={{ maxWidth: '512px' }}>
                    {renderProductCards(Products)}
                </Row>
                :
                <h3>{BlankMessage || <Spin />}</h3>
            }
            <br /><br />

            {PostSize >= Limit &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button onClick={onLoadMore}>더보기</button>
                </div>
            }

            {/* <MapContainer /> */}

        </div>
    )
}

export default LandingPage
